var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header',{attrs:{"title":_vm.title}}),_c('DetailTitle',{attrs:{"info":_vm.detailInfo}}),_c('Chart',{attrs:{"rateList":_vm.rateList}}),_c('DetailBody',{attrs:{"info":_vm.detailInfo}}),_c('Bottom_comp'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }